import { List, Row, Space, Typography } from 'antd'
import CIMSSelect from 'components/CIMSSelect'
import CIMSSection from 'components/CIMSSection'
import { useState } from 'react'
import CSVButton from 'components/CSVButton'
import { alphabeticalSort, CSVEntity, CSVEntityItem } from 'shared'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'

const Exports: React.VFC = () => {
  const [option, setOption] = useState<CSVEntityItem | undefined>()
  const options = useOptions({
    items: CSVEntity.values,
    sort: alphabeticalSort('classType'),
    label: 'classType',
    value: 'id',
  })
  return (
    <Space direction="vertical" size="middle">
      <Typography.Text>Select a record type to export.</Typography.Text>
      <Row style={{ columnGap: 16 }}>
        <CIMSSelect
          style={{ width: 300 }}
          options={options}
          simple
          onChange={(value) => setOption(CSVEntity.fromId(value?.toString()))}
        />
        {option && <CSVButton primary label="Export" entity={option} />}
      </Row>
      {option && (
        <>
          {!option.filtered && (
            <Typography.Paragraph>
              All records are always exported.
            </Typography.Paragraph>
          )}
          <CIMSSection title="Headers">
            <List
              style={{ maxHeight: 400, overflow: 'auto' }}
              size="small"
              dataSource={option?.headers}
              renderItem={(header) => <List.Item>{header}</List.Item>}
            />
          </CIMSSection>
        </>
      )}
    </Space>
  )
}

export default Exports
